<template>
  <div class="goods_index" v-if="result.data">
    <el-breadcrumb separator="/" slot="breadcrumb" class="breadcrumb-bg">
      <el-breadcrumb-item >首页</el-breadcrumb-item>
      <el-breadcrumb-item >订单修改</el-breadcrumb-item>
    </el-breadcrumb>




    <div class="title"><span class="el-icon-notebook-2"></span>订单详细</div>
      <el-card>

          <el-row  v-if="result">
              <el-col
              ><span class="el-icon-right"></span>{{ result.data.oid }} 下单日期:{{
                      formatGMT(result.data.created_time)
                  }}
              </el-col>
          </el-row>

          <div
                  v-for="(v, index) in result.data.order_info"
                  :key="index"
                  class="order_content"

          >

              <el-row class="title">
                  <el-col> 款号：{{v.title}}
                      采购价:{{ v.totalprice }}元

                  </el-col>
              </el-row>

              <el-row  v-for="(vv, index1) in v.detail"
                       :key="index1">
                  <el-col>

                      <img :src="result.data.product_pic_items[vv.color_label+'_'+vv.pro_id]['pic'][0]['url']" v-if="result.data.product_pic_items[vv.color_label+'_'+vv.pro_id]!=null" style="width: 100px; height: 100px" >
                      <span v-else>暂无图片</span>
                  </el-col>
                  <el-col>

                      <p>属性: {{ vv.color_label }}{{ vv.size_label }}</p>

                      数量:<el-input   v-model="form.qty[index][index1]"  @input="setQty($event,index,index1)"  ></el-input>
                     <p>数量:{{ vv.qty }} 价格{{ vv.price }}</p>

                  </el-col>
              </el-row>
          </div>

      </el-card>
      <el-card>

      </el-card>

  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {


        num:0,

        form:{
            oid:"",
            orderno:'',
            express:'',
            qty:{},
            order_id:{}
        },
        id: 0,



    };
  },
  methods: {
    ...mapActions({
      getMyorderDetailAction: "getMyorderDetailAction",
      editorderDataAction:"editorderDataAction"


    }),

      setQty(event,index,index1) {

         console.log(event,index,this.form.order_id[index][index1])

          this.edit(event,this.form.order_id[index][index1])

      },
      edit(data,id){

        this.editorderDataAction({qty:data,id:id})
      },
      // setNum(event,k){
      //
      //     this.qty[k] =event.currentTarget.value;
      // },

    formatGMT(gmt, long) {
      long = false === long ? false : true;
      let date = new Date(gmt);

      let m = date.getMonth() + 1,
        mm = "-" + (m < 10 ? "0" + m : m);
      let d = date.getDate(),
        dd = "-" + (d < 10 ? "0" + d : d);
      let h = date.getHours(),
        hh = " " + (h < 10 ? "0" + h : h);
      let i = date.getMinutes(),
        ii = ":" + (i < 10 ? "0" + i : i);
      let s = date.getSeconds(),
        ss = ":" + (s < 10 ? "0" + s : s);

      return date.getFullYear() + mm + dd + (long ? hh + ii + ss : "");
    },
  },
  created() {
    this.id = this.$route.params.id;

    this.getMyorderDetailAction({ id: this.id });

  },
  //tableData
  computed: mapState({
    result: (state) => state.order.result,


  }),
    watch:{
        result(newdata){
          if(newdata.code==301){
              this.getMyorderDetailAction({ id: this.id });
          }
          if(newdata.code==200){

              this.form.orderno=newdata.data.orderno

              for (const k in newdata.data.order_info) {

                  let qty=[]
                  let order_id=[]
                  let detail=newdata.data.order_info[k]['detail']
                  for (const detailKey in detail) {
                      let item=newdata.data.order_info[k]['detail'][detailKey]
                      qty.push(item['qty'])
                      order_id.push(item['id'])



                  }


                  this.$set(this.form.qty,k,qty)
                  this.$set(this.form.order_id,k,order_id)



              }

          }
        },

    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.dialog-footer {
  text-align: center;
  background-color: gainsboro;
  padding: 0.3rem;
}
</style>
